'use client';
import '@vtmn-play/css/component/VpIconButton.css';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { VpButton } from '../VpButton/VpButton.mjs';
import '../VpButton/VpButtonContent.mjs';

const VpIconButton = forwardRef(({ children, variant, ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    VpButton,
    {
      ...restProps,
      variant,
      _iconOnly: true,
      ref,
      children
    }
  );
});

export { VpIconButton };
